export const environment = {
  production: false,
  hmr: true,
  serverUrl: 'https://procurementapi.elitetraveltech.in',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',

  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  //  serverUrl: 'http://192.168.20.165:8000', //ashutosh
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  //  webserver: 'ws://192.168.20.165:8000',
  // serverUrl: 'http://localhost:1003',//navneet
  // serverUrl: 'http://192.168.20.141:8000', //yash 
  // serverUrl: 'http://localhost:8000', //vishal
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};
